import React, { useState, useEffect } from "react";
import axios from "axios";
import Menu from "../Menu";
import { useNavigate } from "react-router-dom";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";
import useApiUrls from "../../useApiUrls";
import Pagination from "../../components/Pagination";

const DefaultTemplate = () => {
    const [data, setData] = useState([]);
    const [dataLimit, setDataLimit] = useState(100);
    const [count, setCount] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [totalItems, setTotalItems] = useState(0);
    const [message, setMessage] = useState("");

    const navigate = useNavigate();
    const { getUrlByOperation } = useApiUrls();

    const token = getCookie("token");
    const userid = getCookie("userid");

    const fetchTemplateData = async () => {
        try {
            const response = await axios.post(
                'https://api.dqr-display-tms.eventum.co.in/api/DefaultTemplateOperation/SubUser/Search',
                {
                    ispageload: false,
                    pagesize: dataLimit,
                    currentpageno: count,
                    withoutpagination: false,
                    pagedirection: "",
                },
                {
                    headers: {
                        "X-Authorization": token,
                        UserId: userid,
                        "Content-Type": "application/json-patch+json",
                    },
                }
            );

            if (response.data && Array.isArray(response.data.data)) {
                const rows = response.data.data;
                setData(rows);
                setHasMore(rows.length === Number(dataLimit));
                // Calculate approximate total items
                const approximateTotal = (count * Number(dataLimit)) + rows.length + (rows.length === Number(dataLimit) ? Number(dataLimit) : 0);
                setTotalItems(approximateTotal);
            } else {
                setData([]);
                setHasMore(false);
                setTotalItems(0);
            }
        } catch (error) {
            console.error("Error fetching Template data:", error);
            setHasMore(false);
            setTotalItems(0);
        }
    };

    // Pagination navigation functions
    const handleItemsPerPageChange = (newItemsPerPage) => {
        setDataLimit(newItemsPerPage);
        setCount(0); // Reset to first page when changing items per page
    };

    const handlePageChange = (page) => {
        setCount(page - 1); // Convert 1-based page to 0-based index
    };

    useEffect(() => {
        fetchTemplateData();
    }, [getUrlByOperation, token, userid, dataLimit, count]);

    const handleAddPop = () => {
        navigate("/add-Template");
    };

    const handleUpdatePop = (id) => {
        navigate(`/update-Template/${id}`);
    };

    const handleDelete = async (id) => {
        try {
            await axios.post('https://api.dqr-display-tms.eventum.co.in/api/DefaultTemplateOperation/SubUser/Delete', { id }, {
                headers: {
                    "X-Authorization": token,
                    UserId: userid,
                    "Content-Type": "application/json-patch+json",
                },
            });
            setMessage("Data deleted successfully!");
            fetchTemplateData(); // Refresh data after delete
        } catch (error) {
            console.error("Error deleting item:", error);
            setMessage("Failed to delete data");
        }
    };

    // Clean up message after display
    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => {
                setMessage("");
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [message]);

    return (
        <>
            <Menu />
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content-header">
                        <div className="container-fluid">
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <h1 className="mb-0">Template</h1>
                                <button type="button" className="btn btn-success" onClick={handleAddPop}>
                                    Add Template
                                </button>
                            </div>
                        </div>
                    </section>

                    <section className="content">
                        <div className="container-fluid">
                            <hr />
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body table-responsive p-0">
                                            <table className="table table-hover text-nowrap">
                                                <thead>
                                                    <tr>
                                                        <th>Id</th>
                                                        <th>Group Name</th>
                                                        <th>Sub Group Name</th>
                                                        <th>Catalogue Name</th>
                                                        <th>HTML Document Name</th>
                                                        <th>HTML Doc Zip Name</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.id}</td>
                                                            <td>{item.groupname === "all" ? "All" : item.groupname}</td>
                                                            <td>{item.subgroupname === "all" ? "All" : item.subgroupname}</td>
                                                            <td>{item.catalogname === "none" ? "None" : item.catalogname}</td>
                                                            <td>{item.htmldocname === "none" ? "None" : item.htmldocname}</td>
                                                            <td>{item.htmldoczipname === "none" ? "None" : item.htmldoczipname}</td>

                                                            <td>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary mr-2"
                                                                    onClick={() => handleUpdatePop(item.id)}
                                                                >
                                                                    <i className="fas fa-edit"></i>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger"
                                                                    onClick={() => handleDelete(item.id)}
                                                                >
                                                                    <i className="fas fa-trash"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <Pagination
                                            currentPage={count + 1}
                                            totalPages={hasMore ? count + 2 : count + 1}
                                            onPageChange={handlePageChange}
                                            itemsPerPage={Number(dataLimit)}
                                            onItemsPerPageChange={handleItemsPerPageChange}
                                            totalItems={totalItems}
                                            showPageNumbers={false}
                                            showItemsPerPageSelector={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            {message === "Data deleted successfully!" && <SuccessMessage message={message} />}
            {message === "Failed to delete data" && <FailedMessage message={message} />}
        </>
    );
};

export default DefaultTemplate;

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
}
